"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tag = Tag;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const utils_1 = require("@react-aria/utils");
const react_1 = require("react");
const components_1 = require("./");
const Css_1 = require("../Css");
const utils_2 = require("../utils");
/** Tag used for indicating a status */
function Tag(props) {
    const { text, type, xss, preventTooltip = false, ...otherProps } = props;
    const typeStyles = getStyles(type);
    const tid = (0, utils_2.useTestIds)(otherProps);
    const [showTooltip, setShowTooltip] = (0, react_1.useState)(false);
    const ref = (0, react_1.useRef)(null);
    (0, utils_1.useResizeObserver)({
        ref,
        onResize: () => {
            if (ref.current) {
                setShowTooltip(ref.current.offsetHeight < ref.current.scrollHeight);
            }
        },
    });
    return (0, components_1.maybeTooltip)({
        title: !preventTooltip && showTooltip ? text : undefined,
        children: ((0, jsx_runtime_1.jsxs)("span", { ...tid, css: { ...Css_1.Css.dif.tinySb.ttu.aic.gapPx(4).pxPx(6).pyPx(2).gray900.br4.$, ...typeStyles, ...xss }, children: [otherProps.icon && ((0, jsx_runtime_1.jsx)("span", { css: Css_1.Css.fs0.$, children: (0, jsx_runtime_1.jsx)(components_1.Icon, { icon: otherProps.icon, inc: 1.5 }) })), (0, jsx_runtime_1.jsx)("span", { ref: ref, css: Css_1.Css.lineClamp1.wbba.$, children: text })] })),
    });
}
function getStyles(type) {
    switch (type) {
        case "info":
            return Css_1.Css.bgBlue100.$;
        case "caution":
            return Css_1.Css.bgYellow200.$;
        case "warning":
            return Css_1.Css.bgRed200.$;
        case "success":
            return Css_1.Css.bgGreen200.$;
        default:
            // Neutral case
            return Css_1.Css.bgGray200.$;
    }
}
